// translateModal.js
import { createModal } from './modal.js';

export function createTranslateModal({ currLang, curPage, updateToolboxTranslations }) {
  // translateModal.js
  // translateModal.js
  function buildContent() {
    updateToolboxTranslations();

    if (curPage.includes('vernatics_factory')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'translate-modal';
      wrapper.innerHTML = initializeVernaticsModal(currLang);
      return wrapper;
    }

    // every other page (including factory / python_factory / vernatics_esp)
    // uses the same dropdown + #codeHolder pre
    const wrapper = document.createElement('div');
    wrapper.className = 'translate-modal';

    const dropdownBar = document.createElement('div');
    dropdownBar.className = 'translate-modal__bar';
    dropdownBar.textContent = currLang['UI.GenerateLabel'];

    const select = document.createElement('select');
    select.id = 'languageDropdown';
    select.className = 'translate-modal__select';
    if (location.href.includes('python')) select.disabled = true;

    [
      ['javascript', 'JavaScript'],
      ['python', 'Python'],
      ['php', 'PHP'],
      ['lua', 'Lua'],
      ['dart', 'Dart'],
    ].forEach(([value, label]) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = label;
      if (location.href.includes('python') && value === 'python') option.selected = true;
      select.appendChild(option);
    });

    select.addEventListener('change', () => window.myUpdateFunction());
    dropdownBar.appendChild(select);

    const codeHolder = document.createElement('pre');
    codeHolder.id = 'codeHolder';
    codeHolder.className = 'w3-code jsHigh notranslate translate-modal__code';

    wrapper.append(dropdownBar, codeHolder);
    return wrapper;
  }
  return createModal({
    title: () => currLang['CodeButton.Text'] ?? 'Translate',
    closable: true,
    size: 'lg',
    content: buildContent,
    onOpen: () => {
      // refresh to the current workspace state every time the modal opens,
      // in case blocks changed while it was closed
      if (document.getElementById('languageDropdown')) {
        window.myUpdateFunction();
      }
    },
  });
}
